export enum  AuthProvider {
    odocert = 1,
    facebook,
    google
}

// export const AuthProviderKeys = Object.values(AuthProvider).filter(v => typeof v === 'string') as string[];